import clsx from 'clsx';

import Colors from '@dynatrace/strato-design-tokens/colors';

import {
  HIGHLIGHTED_SEGMENT_VALUE,
  INACTIVE_SEGMENT_VALUE,
} from './types/default.js';
import { getTokenComputedStyle } from '../../../../core/utils/getTokenComputedStyle.js';
import { getValidColor } from '../../../../core/utils/getValidColor.js';
import { DEFAULT_GAP_WIDTH, METER_BAR_SIZE } from '../../constants.js';
import { useMeterBarLayoutSize } from '../../context/MeterBarLayoutSizeContext.js';
import { elementSize } from '../../styles/element-size.sty.js';
import { getDashArray } from '../../utils/get-dash-array.js';

interface MeterBarSegmentProps {
  color: string;
  width: number;
  highlighted?: boolean;
  start?: number;
}

export const MeterBarSegment = (props: MeterBarSegmentProps) => {
  const { color, width, highlighted = true, start = 0 } = props;

  const validColor = getTokenComputedStyle(getValidColor(color));

  const { size, segmentHeight } = useMeterBarLayoutSize();

  const dashArray = getDashArray(width, segmentHeight);

  const isSegmentHeight = size === METER_BAR_SIZE.Auto;

  return (
    <rect
      className={clsx({ [elementSize({ size })]: !isSegmentHeight })}
      x={start}
      y="0"
      height={isSegmentHeight ? segmentHeight : undefined}
      width={width}
      fill={validColor}
      opacity={highlighted ? HIGHLIGHTED_SEGMENT_VALUE : INACTIVE_SEGMENT_VALUE}
      data-testid="meterbar-segment"
      stroke={Colors.Background.Base.Default}
      strokeWidth={DEFAULT_GAP_WIDTH}
      strokeDasharray={dashArray}
    />
  );
};
